import { skipToken, useQuery } from '@tanstack/react-query';

import { carFinanceApi } from '../../../../api/carFinanceApi';

import {
  type QueryParameters,
  carFinanceInitialFormDataSchema,
  mappedQueryParameterSchema,
} from '../schema/carFinance.schema';

import { serialise } from '../../../../helpers/formatSearchTerms';
import { PAGE } from '../../../../helpers/pages';

const mapAndSerialise = (query: QueryParameters) => {
  const mappedQuery = mappedQueryParameterSchema.parse(query);

  return serialise(mappedQuery);
};

const getCarFinanceInitialFormData = async (params: string) => {
  const { data } = await carFinanceApi.getCarFinance(params);

  return carFinanceInitialFormDataSchema.parse(data);
};

export const useGetCarFinanceInitialFormData = (query?: QueryParameters) => {
  return useQuery({
    queryKey: ['getCarFinanceInitialFormData'],
    queryFn: query
      ? () => {
          return getCarFinanceInitialFormData(mapAndSerialise(query));
        }
      : skipToken,
    staleTime: Infinity,
    meta: { noToast: true, tags: [PAGE.CAR_FINANCE] },
  });
};
